<template>
  <RoutesList/>
</template>
<script>
import RoutesList from '@/components/modules/schoolroutes/routes/list'
export default {
  name: 'routes',
  components: {
    RoutesList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/asignate/list.vue